const sectionCollapsibleProductGridCss = `
[data-type='section-collapsible-product-grid'] .collapsible-product-grid {
  padding: 40px 0;
}

[data-type='section-collapsible-product-grid'] .collapsible-product-grid-title {
  font-size: 28px;
  font-weight: bold !important;
  text-align: center;
  margin: 0 0 30px 0 !important;
}

[data-type='section-collapsible-product-grid'] .collapsible-product-grid-content {
  width: 100%;
  margin: 0 auto;
  text-align: center;
  padding-bottom: 55px !important;
}

[data-type='section-collapsible-product-grid'] .collapsible-product-grid-list {
  width: 100%;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 20px;
}

[data-type='section-collapsible-product-grid'] .collapsible-product-grid-item {
  box-shadow: 0 2px 10px rgba(49, 52, 56, 0.15);
  border-radius: 10px;
  padding: 0 15px 30px;
  margin-top: 45px !important;
  border: solid 1px #d2d2d2;
  overflow: visible;
  align-self: flex-start;
}

[data-type='section-collapsible-product-grid'] .collapsible-product-grid-item-head {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

[data-type='section-collapsible-product-grid'] .collapsible-product-grid-item-meta {
  display: flex;
  flex-direction: column;
}

[data-type='section-collapsible-product-grid'] .collapsible-product-grid-item-image {
  width: 100px;
  height: 100px;
  margin: 0 auto;
  top: -45px;
  position: relative;
}

[data-type='section-collapsible-product-grid'] .collapsible-product-grid-item-title {
  font-size: 20px;
  line-height: 24px;
  font-weight: 600;
  min-height: 52px;
  margin: -25px 0 20px 0 !important;
  padding: 0;
  max-width: 100%;
  width: 100%;
}

[data-type='section-collapsible-product-grid'] .collapsible-product-grid-item-button {
  cursor: pointer;
  width: 100%;
  display: flex;
  justify-content: center;
  gap: 10px;
  align-items: center;
}

[data-type='section-collapsible-product-grid'] .collapsible-product-grid-item-button-icon svg {
  width: 10px;
  height: 10px;
}

[data-type='section-collapsible-product-grid'] .collapsible-product-grid-item-button-text {
  text-decoration: underline;
  text-align: center;
  display: inline-block;
  margin-right: 10px !important;
  font-weight: 700;
}

[data-type='section-collapsible-product-grid'] .collapsible-product-grid-item-content {
  margin-top: 30px;
  text-align: center;
  line-height: 24px;
}

[data-type='section-collapsible-product-grid'] .collapsible-product-grid-item-content p {
  margin: 0 !important;
}

@container (max-width: 768px) {
  [data-type='section-collapsible-product-grid'] .collapsible-product-grid {
    padding: 16px 0;
  }

  [data-type='section-collapsible-product-grid'] .collapsible-product-grid-title {
    font-size: 18px;
    margin-bottom: 20px !important;
  }

  [data-type='section-collapsible-product-grid'] .collapsible-product-grid-content {
    font-size: 14px;
    padding-bottom: 20px !important;
  }

  [data-type='section-collapsible-product-grid'] .collapsible-product-grid-list {
    grid-template-columns: repeat(1, minmax(0, 1fr));
    gap: 8px;
  }

  [data-type='section-collapsible-product-grid'] .collapsible-product-grid-item {
    border: none;
    box-shadow: none;
    margin-top: 0 !important;
    padding: 4px 0;
    border-radius: 0;
    background-color: transparent !important;
  }

  [data-type='section-collapsible-product-grid'] .collapsible-product-grid-item-head {
    flex-direction: row;
    justify-content: space-between;
    gap: 8px;
  }

  [data-type='section-collapsible-product-grid'] .collapsible-product-grid-item-meta {
    flex-direction: row;
    align-items: center;
    gap: 16px;
  }

  [data-type='section-collapsible-product-grid'] .collapsible-product-grid-item-image {
    width: 40px;
    height: 40px;
    top: 0;
  }

  [data-type='section-collapsible-product-grid'] .collapsible-product-grid-item-title {
    font-size: 16px;
    min-height: auto;
    margin: 0 !important;
  }

  [data-type='section-collapsible-product-grid'] .collapsible-product-grid-item-button {
    width: fit-content;
  }

  [data-type='section-collapsible-product-grid'] .collapsible-product-grid-item-button-text {
    display: none;
  }

  [data-type='section-collapsible-product-grid'] .collapsible-product-grid-item-content {
    margin-top: 8px;
    text-align: left;
  }
}
`;

export default sectionCollapsibleProductGridCss;
